/**
 * Which buttons an `ExportButtons` instance shows. Extracted as a pure
 * function because none of the SPAs run jsdom/testing-library — this keeps the
 * only authority-shaped decision in the component unit-testable.
 *
 * Excel and PDF are decided SEPARATELY: the admin gates them on the global
 * `export.excel` / `export.pdf` codes, so a role can be allowed spreadsheets
 * but not PDFs. A surface with one authority for both (the cashier's
 * Consignment tabs, which grandfather `consignment.export`) simply passes the
 * same answer twice.
 *
 * Kept React-free (and out of the `@mlm/ui` barrel) so a plain node test can
 * import it without pulling the component's module graph in — reach it as
 * `@mlm/ui/lib/export-visibility`.
 */
export function exportButtonsVisibility(args: {
  canExcel: boolean;
  canPdf: boolean;
  /** Already folded: the tab has a printable document AND the caller may print. */
  hasPrint: boolean;
}): {
  showExcel: boolean;
  showPdf: boolean;
  showPrint: boolean;
} {
  return { showExcel: args.canExcel, showPdf: args.canPdf, showPrint: args.hasPrint };
}
